import useHistoryHandler from './useHistoryHandler';
import useLocalStorage from './useLocalStorage';
import useTriviaAPI from './useTriviaAPI';

export { useLocalStorage, useTriviaAPI, useHistoryHandler };
